// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_GetcategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Tickets_CategoriaRow } from './Tickets_CategoriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Tickets_GetcategoriasResponseDados = Tickets_CategoriaRow[];

export type Tickets_GetcategoriasResponse = ApiResponse<Tickets_GetcategoriasResponseDados>;

registerResponseContract('Tickets_GetcategoriasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:            { type: 'number',  required: true },
      NomeCategoria: { type: 'string',  required: true },
      created_at:    { type: 'string',  required: false },
      updated_at:    { type: 'string',  required: false },
    },
  },
})
